<template>
  <div>
    <b-form @submit.prevent="updateNotes">
    <ckeditor
      :editor="editor"
      v-model="editorData"
      :config="editorConfig"
    ></ckeditor>
    <b-row class="space" align-h="end">
      <b-button type="submit" variant="danger" :disabled="isBusy">
        <b-spinner small v-if="isBusy" class="align-middle"></b-spinner>
        <template v-else>
          Agregar
        </template>        
      </b-button>
    </b-row>
    </b-form>
    <div>
      <note-view
        v-for="note in notes"
        :text="note['texto']"
        :time="note['fechahora']"
        :key="note['id']"
        :contact="note['idcontactodesc']"
        :right="true"
      />
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { notesMethods } from "@/state/helpers";
import NoteView from "./note-view";
export default {
  components: {
    "note-view": NoteView,
  },
  props: {
    tipoObjeto: String,
    idObjeto: Number,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p>Mensaje.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      notes: [],
      isBusy: false
    };
  },
  beforeMount() {
    this.getNotesView();
  },
  methods: {
    ...notesMethods,
    updateNotes() {
      this.isBusy = true;
      const data = {
        idobjeto: this.idObjeto,
        tipoobjeto: this.tipoObjeto,
        texto: this.editorData,
      };
      this.addNote(data)
      .then((res) => {
        if(!res){
          this.$bvToast.toast(
            this.$t("error.añadir-nota.content").toString(), {
            title: this.$t("error.añadir-nota.title").toString(),
            variant: "danger",
            solid: true,
          });
        }
        this.getNotesView();
        this.editorData = "<p>Mensaje.</p>";
        this.$bvToast.toast(
          this.$t("success.añadir-nota.content").toString(), {
          title: this.$t("success.añadir-nota.title").toString(),
          variant: "success",
          solid: true,
        });
        this.isBusy = false;
      })
    },
    getNotesView(){
      this.getAllNotes({
      tipoobjeto: this.tipoObjeto,
      idobjeto: this.idObjeto,
    })
      .then((notes) => {
        if(!notes){
          this.$bvToast.toast(
            this.$t("error.obtener-nota.content").toString(), {
            title: this.$t("error.obtener-nota.title").toString(),
            variant: "danger",
            solid: true,
          });
        }
        this.notes = notes;
      })
    }
  },
};
</script>

<style>
.space {
  padding: 10px;
  margin: 10px 0;
}
</style>